export enum CustomFieldType {
    Number = 'number',
    String = 'string',
    Enum = 'enum'
};

export const CustomFieldFilterTypes = [
    CustomFieldType.Enum,
];